import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const TouchFeedback = () => {
  const [touches, setTouches] = useState([]);

  useEffect(() => {
    const handleTouch = (e) => {
      const touch = e.touches[0] || e.changedTouches[0];
      if (touch) {
        const newTouch = {
          id: Date.now() + Math.random(),
          x: touch.clientX,
          y: touch.clientY
        };
        setTouches(prev => [...prev, newTouch]);

        setTimeout(() => {
          setTouches(prev => prev.filter(t => t.id !== newTouch.id));
        }, 600);
      }
    };

    window.addEventListener('touchstart', handleTouch);
    return () => window.removeEventListener('touchstart', handleTouch);
  }, []);

  return (
    <div className="fixed inset-0 pointer-events-none z-[60]">
      <AnimatePresence>
        {touches.map(touch => (
          <motion.div
            key={touch.id}
            initial={{ scale: 0, opacity: 0.8 }}
            animate={{ scale: 2, opacity: 0 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.6, ease: 'easeOut' }}
            className="absolute w-12 h-12 -translate-x-1/2 -translate-y-1/2"
            style={{
              left: touch.x,
              top: touch.y
            }}
          >
            <div className="w-full h-full rounded-full border-4 border-purple-400" />
          </motion.div>
        ))}
      </AnimatePresence>
    </div>
  );
};

export default TouchFeedback;